import { h } from "@stencil/core";
/**
 * functional stencil component for a question with a comment field
 */
export function QuestionComment({ label, name, answers, setAnswers, placeholder }) {
    return (h("div", null, h("div", { class: "mf-proactive-case-closure__question ux-u-margin-top-40 ux-u-margin-bottom-20" }, label), h("div", null, h("ux-textarea-field", { name: name, placeholder: placeholder, onUxTextareaFieldChange: (e) => setAnswers(Object.assign(Object.assign({}, answers), { [name]: e.detail.value })) }))));
}
//# sourceMappingURL=question-comment.js.map
